export default __webpack_public_path__ + "static/media/Capture1.48c561f6.JPG";